import { Navigate } from "react-router-dom";
import { useCustomerAuthContext } from "./useCustomerAuthContext";
import { isTokenExpired } from "../../api/helpers";

const CustomerProtectedRoute = ({ children }) => {

    const { customer, loading } = useCustomerAuthContext();

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!customer?.token) {
        return <Navigate to="/customer/test-login" replace />;
    }

    if (isTokenExpired(customer.token)) {

        localStorage.removeItem("customer");

        return <Navigate to="/customer/test-login" replace />;

    }

    return children;

};

export default CustomerProtectedRoute;